import { render, staticRenderFns } from "./InputTextEmail.vue?vue&type=template&id=35e7b6c2&"
import script from "./InputTextEmail.vue?vue&type=script&lang=js&"
export * from "./InputTextEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports